import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import Login from './components/Login';
import Dashboard from './components/Page/Dashboard/Dashboard';
import Blank from './components/Global/Blank';
import DashboardACustomer from './components/Page/Dashboard/Customer';
import DashboardAgent from './components/Page/Dashboard/Agent';
import DashboardOwner from './components/Page/Dashboard/Owner';
import Config from './components/Page/Other/Config';
import UserManual from './components/Page/Other/UserManual';
import Buy from './components/Page/Bet/Buy';
import PayWaitingCheck from './components/Page/Bet/PayWaitingCheck';
import History from './components/Page/History';
import Members from './components/Page/Member/Members';
import Profile from './components/Page/Member/Profile';
import ResultsPowerball from './components/Page/Results/ResultsPowerball';
import ResultsMegaMillions from './components/Page/Results/ResultsMegaMillions';
import News from './components/Page/News/List';
import NewsDetail from './components/Page/News/Detail';
import NewsManage from './components/Page/News/Manage';
import ManagePrizesHistory from './components/Page/Prizes/ManagePrizesHistory';
import ManagePrizesNew from './components/Page/Prizes/ManagePrizesNew';
import ManagePrizesNewMega from './components/Page/Prizes/ManagePrizesNewMega';
import SummaryPrizes from './components/Page/Prizes/SummaryPrizes';
import SummaryPrizesHistory from './components/Page/Prizes/SummaryPrizesHistory';
import ReportWinning from './components/Page/Report/Winning';
import ReportMembersWinning from './components/Page/Report/MembersWinning';
import MembersAgent from './components/Page/Report/MembersAgent';
import ReportCreditMemberBet from './components/Page/Report/CreditMemberBet';
import RulesViews from './components/Page/Rules/Views';
import LineQRCode from './components/Page/Other/LineQRCode';
import RulesManage from './components/Page/Rules/Manage';
import NotFound from './components/Error/NotFound';
import Forbidden from './components/Error/Forbidden';
import { API_CONFIG } from './contexts/constants';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('userRole');
    if (token) {
      setIsAuthenticated(true);
      if (role) setUserRole(role);
    }
    setLoading(false);
  }, []);

  const handleLogin = (role) => {
    setIsAuthenticated(true);
    setUserRole(role);
  };
  const handleLogout = async () => {
	await axios.post(`${API_CONFIG.BASE_URL}/logout`, {}, {
		headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
	});
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem('userRole');
    setIsAuthenticated(false);
    setUserRole(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600 dark:text-gray-400">กำลังโหลด...</p>
        </div>
      </div>
    );
  }

  return (
    <ThemeProvider>
      <Router>
        <div className="min-h-screen font-sans bg-background-light dark:bg-background-dark transition-colors text-black">
			<Routes>
				<Route path="/login"
					element={!isAuthenticated ? <Login onLogin={handleLogin} /> : <Navigate to={userRole === 'owner' ? "/dashboard" : "/home"} />}
				/>
				<Route path="/dashboard"
					element={isAuthenticated ? <Dashboard onLogout={handleLogout} userRole={userRole} /> : <Navigate to="/login" />}
				/>
				<Route path="/home"
					element={isAuthenticated ? (userRole === 'owner' || userRole === 'admin' ? <DashboardOwner onLogout={handleLogout} userRole={userRole} /> : (userRole === 'agent' ? <DashboardAgent onLogout={handleLogout} userRole={userRole} /> : <DashboardACustomer onLogout={handleLogout} userRole={userRole} />)) : <Navigate to="/login" />}
				/>
				<Route path="/bet-order"
					element={isAuthenticated ? <Buy onLogout={handleLogout} userRole={userRole} /> : <Navigate to="/login" />}
				/>
				<Route path="/members/manage"
					element={isAuthenticated ? <Members onLogout={handleLogout} userRole={userRole} /> : <Navigate to="/login" />}
				/>
				<Route path="/agents/manage"
					element={isAuthenticated ? <Members onLogout={handleLogout} userRole={userRole} /> : <Navigate to="/login" />}
				/>
				<Route path="/bet/pay-waiting"
					element={isAuthenticated ? <PayWaitingCheck onLogout={handleLogout} userRole={userRole} /> : <Navigate to="/login" />}
				/>
				<Route path="/members/history-bet"
					element={isAuthenticated ? <ReportCreditMemberBet onLogout={handleLogout} userRole={userRole} creditRole="owner" /> : <Navigate to="/login" />}
				/>
				<Route path="/results/winning"
					element={isAuthenticated ? <ReportWinning onLogout={handleLogout} userRole={userRole} menuName="ลูกค้าที่ถูกรางวัล" /> : <Navigate to="/login" />}
				/>
				<Route path="/results/results-powerball"
					element={isAuthenticated ? <ResultsPowerball onLogout={handleLogout} userRole={userRole} /> : <Navigate to="/login" />}
				/>
				<Route path="/results/results-megamillions"
					element={isAuthenticated ? <ResultsMegaMillions onLogout={handleLogout} userRole={userRole} /> : <Navigate to="/login" />}
				/>
				<Route path="/results/history"
					element={isAuthenticated ? <History onLogout={handleLogout} userRole={userRole} /> : <Navigate to="/login" />}
				/>
				<Route path="/manage_data/prizes-manage-powerball"
					element={isAuthenticated ? <ManagePrizesNew onLogout={handleLogout} userRole={userRole} /> : <Navigate to="/login" />}
				/>
				<Route path="/manage_data/prizes-manage-megamillions"
					element={isAuthenticated ? <ManagePrizesNewMega onLogout={handleLogout} userRole={userRole} /> : <Navigate to="/login" />}
				/>
				<Route path="/manage_data/prizes-history"
					element={isAuthenticated ? <ManagePrizesHistory onLogout={handleLogout} userRole={userRole} /> : <Navigate to="/login" />}
				/>
				<Route path="/manage_data/prizes-summary-powerball"
					element={isAuthenticated ? <SummaryPrizes onLogout={handleLogout} userRole={userRole} lotType="powerball" /> : <Navigate to="/login" />}
				/>
				<Route path="/manage_data/prizes-summary-megamillions"
					element={isAuthenticated ? <SummaryPrizes onLogout={handleLogout} userRole={userRole} lotType="megamillions" /> : <Navigate to="/login" />}
				/>
				<Route path="/manage_data/prizes-summary-history"
					element={isAuthenticated ? <SummaryPrizesHistory onLogout={handleLogout} userRole={userRole} /> : <Navigate to="/login" />}
				/>
				<Route path="/history/bet-action"
					element={isAuthenticated ? <ReportCreditMemberBet onLogout={handleLogout} userRole={userRole} /> : <Navigate to="/login" />}
				/>
				<Route path="/rules/view-powerball"
					element={isAuthenticated ? <RulesViews onLogout={handleLogout} userRole={userRole} menuType="rules-powerball" /> : <Navigate to="/login" />}
				/>
				<Route path="/rules/view-megamillions"
					element={isAuthenticated ? <RulesViews onLogout={handleLogout} userRole={userRole} menuType="rules-megamillions" /> : <Navigate to="/login" />}
				/>
				<Route path="/rules/manage"
					element={isAuthenticated ? <RulesManage onLogout={handleLogout} userRole={userRole} /> : <Navigate to="/login" />}
				/>
				<Route path="/report/winning"
					element={isAuthenticated ? <ReportWinning onLogout={handleLogout} userRole={userRole} exportExcel="true" menuName="รายการผู้ถูกรางวัล" /> : <Navigate to="/login" />}
				/>
				<Route path="/report/members-winning"
					element={isAuthenticated ? <ReportMembersWinning onLogout={handleLogout} userRole={userRole} menuName="รายงานผู้ใช้งานที่ซื้อ" /> : <Navigate to="/login" />}
				/>
				<Route path="/report/members-agent"
					element={isAuthenticated ? <MembersAgent onLogout={handleLogout} userRole={userRole} /> : <Navigate to="/login" />}
				/>
				<Route path="/report/credit-member-bet"
					element={isAuthenticated ? <ReportCreditMemberBet onLogout={handleLogout} userRole={userRole} creditRole="owner" exportExcel="true" menuType="report" /> : <Navigate to="/login" />}
				/>
				<Route path="/config"
					element={isAuthenticated ? <Config onLogout={handleLogout} userRole={userRole} /> : <Navigate to="/login" />}
				/>
				<Route path="/news/views"
					element={isAuthenticated ? <News onLogout={handleLogout} userRole={userRole} /> : <Navigate to="/login" />}
				/>
				<Route path="/news/manage"
					element={isAuthenticated ? <NewsManage onLogout={handleLogout} userRole={userRole} /> : <Navigate to="/login" />}
				/>
				<Route path="/news/views/:id"
					element={isAuthenticated ? <NewsDetail onLogout={handleLogout} userRole={userRole} /> : <Navigate to="/login" />}
				/>
				<Route path="/profile"
					element={isAuthenticated ? <Profile onLogout={handleLogout} userRole={userRole} /> : <Navigate to="/login" />}
				/>
				<Route path="/"
					element={<Navigate to={isAuthenticated ? '/home' : '/login'} />}
				/>
				<Route path="/line-qrcode"
					element={isAuthenticated ? <LineQRCode onLogout={handleLogout} userRole={userRole} /> : <Navigate to="/login" />}
				/>
				<Route path="/user-manual"
					element={isAuthenticated ? <UserManual onLogout={handleLogout} userRole={userRole} /> : <Navigate to="/login" />}
				/>
				<Route path="/blank"
					element={isAuthenticated ? <Blank onLogout={handleLogout} userRole={userRole} /> : <Navigate to="/login" />}
				/>
				<Route path="/forbidden" element={<Forbidden />} />
				<Route path="/403" element={<Forbidden />} />
				<Route path="/404" element={<NotFound />} />
				<Route path="*" element={<NotFound />} />
			</Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
